import { __ } from '@wordpress/i18n';
import InspectorPresetsSelector from '../inspector-presets-selector';
import { getBlockVariations, createBlock } from '@wordpress/blocks';
import {
	InspectorControls,
	useBlockEditContext,
} from '@wordpress/block-editor';
import { useDispatch, useSelect } from '@wordpress/data';

const InspectorSelectBlockVariation = ( props ) => {
	const {
		label,
		value,
		options,
		attributes,
		setAttributes,
		onChange = () => {},
	} = props;

	const { clientId, name = 'alphablock/hero' } = useBlockEditContext();
	const { replaceBlock } = useDispatch( 'core/block-editor' );
	// const variations = useSelect(() =>
	//   wp.data.select('core/blocks').getBlockVariations('alphablock/hero_style_main', 'transform') || []
	// );
	const variations = getBlockVariations( name, 'block' ) || [];

	const styleOptions = variations
		.map( ( variation ) => ( {
			value: variation.name,
			title: variation.title,
			image:
				variation.example?.attributes?.previewImage ||
				'https://placehold.co/200x200/transparent/333',
		} ) )
		.filter( ( option ) => !! option.value );

	const handleVariationChange = ( variationName ) => {
		const variations = getBlockVariations( name, 'block' );

		console.log( 'Variation Changes to :', variationName );

		const variation = variations.find( ( v ) => v.name === variationName );
		if ( ! variation ) return;

		const newAttributes = {
			...attributes,
			...variation.attributes,
		};

		console.log( 'newAttributes: ', newAttributes );

		const newBlock = createBlock( name, newAttributes );
		replaceBlock( clientId, newBlock );
	};

	return (
		<>
			<InspectorPresetsSelector
				label={ __( 'Select Styles', 'alpha' ) }
				value={ attributes.currentStyle }
				onChange={ ( value ) => handleVariationChange( value ) }
				defaultValue={ 'two' }
				options={ styleOptions }
			/>
		</>
	);
};

export default InspectorSelectBlockVariation;
